import {
  object,
  number,
  optional,
  union,
  literal,
  boolean,
  transform,
  string,
  pipe,
  type InferInput,
  type InferOutput,
  getDefaults,
} from 'valibot';

export const LotStatusOptions = ['Sold', 'Include Pending'] as const;

export const LotStatusSchema = union(
  LotStatusOptions.map((option) => literal(option))
);

export type LotStatus = InferOutput<typeof LotStatusSchema>;

export const LatLongParamSchema = object({
  state: optional(string()),
  zip: optional(string()),
  county: optional(string()),
  city: optional(string()),
});

export type LatLongParamInput = InferInput<typeof LatLongParamSchema>;

const strToBool = (val: string) => {
  return val === 'true';
};

export const SearchFiltersSchema = object({
  maxPrice: optional(pipe(string(), transform(Number), number())),
  minPrice: optional(pipe(string(), transform(Number), number())),
  minSize: optional(pipe(string(), transform(Number), number())),
  maxSize: optional(pipe(string(), transform(Number), number())),
  includeNonVacantLots: optional(
    pipe(string(), transform(strToBool), boolean()),
    'false'
  ),
  lotStatus: optional(LotStatusSchema),
});

export type SearchFiltersInput = InferInput<typeof SearchFiltersSchema>;
export type SearchFiltersOutput = InferOutput<typeof SearchFiltersSchema>;

export const sortOrderOptions = [
  'Price Low to high',
  'Price High to low',
  'Lot Size Smallest to Largest',
  'Lot Size Largest to Smallest',
  'Newest',
  'Favorites',
  'Recently Updated',
] as const;

// Create a union of literals for sort order options
export const SortOrderSchema = union(
  sortOrderOptions.map((option) => literal(option))
);

export type SortOrder = InferOutput<typeof SortOrderSchema>;

const safeJSONParse = (val: string) => {
  try {
    return JSON.parse(val);
  } catch (_) {
    return undefined;
  }
};

export const SearchLeversSchema = object({
  page: optional(pipe(string(), transform(Number), number()), '1'),
  sort: optional(
    pipe(string(), transform(safeJSONParse), SortOrderSchema),
    'Price Low to high'
  ),
});

// Schema for search parameters
export const SearchParamsSchema = object({
  ...LatLongParamSchema.entries,
  ...SearchFiltersSchema.entries,
  ...SearchLeversSchema.entries,
});

export type SearchParamsInput = InferInput<typeof SearchParamsSchema>;
export type SearchParamsOutput = InferOutput<typeof SearchParamsSchema>;

export const defaultSearchParams = getDefaults(SearchParamsSchema);

export const SEARCH_LIMIT = 100;
